import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'osFullname'
})
export class OsFullnamePipe implements PipeTransform {

  transform(value: string): string {
    if(!value || value.length==0)return "";
    if (value.indexOf("6.1") > -1) {
      return "Windows 7";
    } else if (value.indexOf("6.2") > -1) {
      return "Windows 8";
    } else if (value.indexOf("6.3") > -1) {
      return "Windows 8.1";
    } else if (value.indexOf("10") > -1) {
      return "Windows 10";
    }else return "نامعلوم";
  }

}
